<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">電子公告</h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          ELECTRONIC PUBLIC NOTICE
        </h3>

        <div class="l-service-content-inner">
          <p class="sentence sentence-mt">
            電子公告については下記のリンク先をご覧ください。
          </p>
          <div class="ir_notice">
            <div id="irMkr">
              <dl>
                <dd>
                  <a
                    href="http://kmasterplus.pronexus.co.jp/main/corp/6/5/6548/index.html"
                    target="_blank"
                    >株式会社旅工房 電子公告</a
                  >
                </dd>
              </dl>
            </div>
            <p>※外部サイトへアクセスします。</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "電子公告",
      titleTemplate: "電子公告 | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
